const organization_form = {
  'Joint stock company with the participation of the state': 'АТ за участю держави (Акціонерне товариство за участю держави)',
  'Individual entrepreneur': 'ФОП (Фізична особа підприємець)',
  'Limited Liability Company': 'TOB (Товариство з обмеженою відповідальністю)',
  'Private enterprise': 'ПП (Приватне підприємство)',
  'Joint stock company': 'АТ (Акціонерне товариство)',
  'Utility Enterprise': 'КП (Комунальне підприємство)',
  'State Enterprise': 'ДП (Державне підприємство)',
  'Other': 'Інша',
}

const regions = {
  "Vinnytsia": 'Вінницька',
  "Volyn": 'Волинська',
  "Dnipropetrovska": 'Дніпропетровська',
  "Donetsk": 'Донецька',
  "Zhytomyr": 'Житомирська',
  "Zakarpattia": 'Закарпатська',
  "Zaporizhzhya": 'Запорізька',
  "Ivan-Frankivsk": 'Івано-Франківська',
  "Kyiv": 'Київська',
  "Kirovograd": 'Кіровоградська',
  "Luhansk": 'Луганська',
  "Lviv": 'Львівська',
  "Mykolaiv": 'Миколаївська',
  "Odesa": 'Одеська',
  "Poltava": 'Полтавська',
  "Rivne": 'Рівненська',
  "Sumy": 'Сумська',
  "Ternopil": 'Тернопільська',
  "Kharkiv": 'Харківська',
  "Kherson": 'Херсонська',
  "Khmelnytsky": 'Хмельницька',
  "Cherkasy": 'Черкаська',
  "Chernivtsi": 'Чернівецька',
  "Kyiv city": 'м.Київ',
  "Chernihiv": 'Чернігівська'
}

const above_min_requirements = {
  "Close to zero energy consumption": 'Близьким до нульового рівнем споживання енергії',
  "Above the minimum requirements": 'Вище мінімальних вимог',
  "Meet the minimum requirements": 'Відповідають мінімальним вимогам',
  "Do not meet the minimum requirements": 'Не відповідають мінімальним вимогам',
}

const ownership_form = {
  'Utility company': 'Комунальне підприємство',
  'Private enterprise (micro, small, medium business)': 'Приватне підприємство (мікро, малий, середній бізнес)',
  'State-owned enterprise': 'Державне підприємство',
  'Other': 'Інша'
}

const field_of_actifity = {
  'governmental': 'державна',
  'communal': 'комунальна',
  'private (small and medium business)': 'приватна (малий-середній бізнес)'
}

const equipment_manufacturers_types = {
  'national producer': 'національного виробника',
  'international manufacturer': 'міжнародного виробника',
  'both variants of manufacturers': 'обидва варіанти виробників'
}

const field_of_activities = {
  'Manufacturing and industry': 'Виробництво та промисловість',
  'Trade and retail': 'Торгівля та роздріб',
  'Finance and banking': 'Фінанси та банківська справа',
  'Information technology': 'Інформаційні технології',
  'Healthcare': 'Охорона здоров\'я',
  'Education and science': 'Освіта і наука',
  'Tourism and hotel business': 'Туризм і готельний бізнес',
  'Agriculture and food industry': 'Сільське господарство та харчова промисловість',
  'Energy and ecology': 'Енергетика та екологія',
  'Construction and real estate': 'Будівництво та нерухомість',
}

const financing_mechanisms_fields  = {
  'Leasing': 'Лізинг',
  'Credit': 'Кредит',
  'Factoring': 'Факторинг',
  'Esco-mechanism': 'Еско-механізм',
  'Grant': 'Грант',
  'Another': 'Інший',
  'None': 'Жодного ',
}

const planned_project_financing_fields  = {
  'Percentage of own funds': 'Власні кошти',
  'Funding from international bodies': 'Фінансування від міжнародних організацій',
  'Grant': 'Грантова допомога',
  'Another': 'Інше',
}


const field_of_activities_obj = {
  'Manufacturing and industry': [
    'Mechanical engineering',
    'Chemical industry',
    'Food industry',
    'Metallurgy',
    'Woodworking',
  ],
  'Trade and retail': [
    'Wholesale trade',
    'Retail trade',
    'Trade in electronic goods',
    'Food trade',
    'Automotive trade',
  ],
  'Finance and banking': [
    'Banking',
    'Investment banking',
    'Insurance',
    'Financial advice',
    'Audit and accounting',
  ],
  'Information technology': [
    'Software development',
    'Web development and design',
    'IT consulting',
    'Cloud services',
    'Cybersecurity',
  ],
  'Healthcare': [
    'Medical services',
    'Pharmaceutical industry',
    'Medical equipment',
    'Dental services',
    'Physiotherapy and rehabilitation',
  ],
  'Education and science': [
    'Higher education',
    'Preschool and school education',
    'Scientific research',
    'Trainings centers',
  ],
  'Tourism and hotel business': [
    'Hotel services',
    'Tour operators',
    'Aviation services',
    'Restaurants and cafes',
    'Travel agencies',
  ],
  'Agriculture and food industry': [
    'Plant growing',
    'Livestock',
    'Fisheries and aquaculture',
    'Food processing',
    'Winemaking and production of alcoholic beverages',
  ],
  'Energy and ecology': [
    'Electric power industry',
    'Alternative energy sources',
    'Recycling',
    'Environmental consulting services',
    'Water supply and water treatment',
  ],
  'Construction and real estate': [
    'Housing construction',
    'Commercial construction',
    'Architectural services',
    'Property management',
    'Repair and maintenance of buildings',
  ],
  'Other': [
    'Other',
  ]
}


const type = {
  'Government': 'Державна',
  'Commercial': 'Комерційна',
  'Non-profit': 'Некомерційна',
  'Budget': 'Бюджетна / Громадська',
  'Public': 'Інша',
  'Religious': 'Релігійна',
}

const type_of_org_activities = {
  'Mechanical engineering': 'Машинобудування',
  'Chemical industry': 'Хімічна промисловість',
  'Food industry': 'Харчова промисловість',
  'Metallurgy': 'Металургія',
  'Woodworking': 'Деревообробка',
  'Wholesale trade': 'Оптова торгівля',
  'Retail trade': 'Роздрібна торгівля',
  'Trade in electronic goods': 'Торгівля електронікою',
  'Food trade': 'Харчова торгівля',
  'Automotive trade': 'Автомобільна торгівля',
  'Banking': 'Банківська справа',
  'Investment banking': 'Інвестиційний банкінг',
  'Insurance': 'Страхування',
  'Financial advice': 'Фінансові консультації',
  'Audit and accounting': 'Облік і аудит',
  'Software development': 'Розробка програмного забезпечення',
  'Web development and design': 'Веб-розробка та дизайн',
  'IT consulting': 'IT консалтинг',
  'Cloud services': 'Хмарні сервіси',
  'Cybersecurity': 'Кібербезпека',
  'Medical services': 'Медичні послуги',
  'Pharmaceutical industry': 'Фармацевтична промисловість',
  'Medical equipment': 'Медичне обладнання',
  'Dental services': 'Стоматологічні послуги',
  'Physiotherapy and rehabilitation': 'Фізіотерапія та реабілітація',
  'Higher education': 'Вища освіта',
  'Preschool and school education': 'Дошкільна та шкільна освіта',
  'Scientific research': 'Наукові дослідження',
  'Trainings centers': 'Навчальні центри',
  'Hotel services': 'Готельні послуги',
  'Tour operators': 'Туроператори',
  'Aviation services': 'Авіаційні послуги',
  'Restaurants and cafes': 'Ресторани та кафе',
  'Travel agencies': 'Туристичні агентства',
  'Plant growing': 'Рослинництво',
  'Livestock': 'Тваринництво',
  'Fisheries and aquaculture': 'Рибальство та аквакультура',
  'Food processing': 'Харчова промисловість',
  'Winemaking and production of alcoholic beverages': 'Виноробство та виробництво алкогольних напоїв',
  'Electric power industry': 'Електроенергетика',
  'Alternative energy sources': 'Альтернативні джерела енергії',
  'Recycling': 'Переробка',
  'Environmental consulting services': 'Екологічний консалтинг',
  'Water supply and water treatment': 'Водопостачання та очищення води',
  'Housing construction': 'Будівництво житла',
  'Commercial construction': 'Комерційне будівництво',
  'Architectural services': 'Архітектурні послуги',
  'Property management': 'Управління нерухомістю',
  'Repair and maintenance of buildings': 'Ремонт та обслуговування будівель',
}

const property_type = {
  'Own': 'У власності',
  'Rent': 'Оренда',
}

const roof_type = {
  'Composition / Asphalt Shingle': 'Композитна / Бітумна черепиця',
  'Flat Concrete': 'Плоскі бетонні конструкції',
  'Flat Foam': 'Плоскі пінопластові плити',
  'Membrane EPDM': 'ЕПДМ мембрана',
  'Membrane PVC': 'ПВХ мембрана',
  'Membrane TPO': 'ТПО мембрана',
  'Metal Decramastic': 'Пресована металочерепиця',
  'Metal Shingle': 'Металочерепиця',
  'Metal Standing Seam': 'Фальцева покрівля',
  'Metal Stone Coated': "Металокераміка ",
  'Metal Tin': "Металева бляха",
  'Tar and Gravel / Bitumen': 'Дьоготь і гравій / Бітум',
  'Thatched': "Соломʼяний",
  'Tile Clay': 'Керамічна черепиця',
  'Tile Concrete': 'Бетонна черепиця',
  'Tile Slate': 'Шифер',
  'Wood / Shake Shingle': "Деревʼяна / Гонтова черепиця",
  'Other': 'Інше',
  'Kliplock': 'Система кріплення кліп-лок',
}

const roof_direction = {
  'South': 'Південний',
  'South East': 'Південно-східний',
  'South West': 'Південно-західний',
  'East': 'Східний',
  'West': 'Західний',
  'North': 'Північний',
  'North East': 'Північно-східний',
  'North West': 'Північно-західний',
}

const electricity_supplier = {
  'ТОВ "Д.ТРЕЙДІНГ"': 'ТОВ "Д.ТРЕЙДІНГ"',
  'ТОВ "КИЇВСЬКІ ЕНЕРГЕТИЧНІ ПОСЛУГИ"': 'ТОВ "КИЇВСЬКІ ЕНЕРГЕТИЧНІ ПОСЛУГИ"',
  'ТОВ "ДНІПРОВСЬКІ ЕНЕРГЕТИЧНІ ПОСЛУГИ"': 'ТОВ "ДНІПРОВСЬКІ ЕНЕРГЕТИЧНІ ПОСЛУГИ"',
  'ТОВ "КИЇВСЬКА ОБЛАСНА ЕНЕРГОПОСТАЧАЛЬНА КОМПАНІЯ"': 'ТОВ "КИЇВСЬКА ОБЛАСНА ЕНЕРГОПОСТАЧАЛЬНА КОМПАНІЯ"',
  'ТОВ "ОДЕСЬКА ОБЛАСНА ЕНЕРГОПОСТАЧАЛЬНА КОМПАНІЯ"': 'ТОВ "ОДЕСЬКА ОБЛАСНА ЕНЕРГОПОСТАЧАЛЬНА КОМПАНІЯ"',
  'ТОВ "ЕНЕРГО ЗБУТ ТРАНС"': 'ТОВ "ЕНЕРГО ЗБУТ ТРАНС"',
  'ПРАТ "ХАРКІВЕНЕРГОЗБУТ"': 'ПРАТ "ХАРКІВЕНЕРГОЗБУТ"',
  'ТОВ "ЛЬВІВЕНЕРГОЗБУТ"': 'ТОВ "ЛЬВІВЕНЕРГОЗБУТ"',
  'ТОВ "ДОНЕЦЬКІ ЕНЕРГЕТИЧНІ ПОСЛУГИ"': 'ТОВ "ДОНЕЦЬКІ ЕНЕРГЕТИЧНІ ПОСЛУГИ"',
  'ТОВ "ПОЛТАВАЕНЕРГОЗБУТ"': 'ТОВ "ПОЛТАВАЕНЕРГОЗБУТ"',
  'ТОВ "ЕНЕРА ВІННИЦЯ"': 'ТОВ "ЕНЕРА ВІННИЦЯ"',
}

const required_voltage = {
  '110-127 V': '110-127 В',
  '220-240 V': '220-240 В',
  '380 V': '380 В',
}


const ua = {
  'Enter data for month': 'Введіть значення за місяць',
  'Other Type': 'Інший',
  'Enter the form of ownership of your company': 'Введіть форму власності вашого підприємства',
  'Form of ownership of your company': 'Форма власності вашого підприємства',
  'Enter a supporting document for the implementation of the energy management system': 'Введіть підтверджуючий документ щодо впровадження системи енергоменеджменту',
  'Implemented energy management system according to ISO 50001': 'Наявність впровадженної системи енергоменеджменту за ISO 50001',
  'If you have a different project area, describe the energy resource reduction indicators that will be achieved through its implementation': 'Якщо у вас інший напрям проєкту, опишіть показники скорочення енергетичних ресурсів, які будуть досягнуті за його реалізації',
  'For thermal modernization and energy efficiency projects in buildings': 'Для проєктів з термомодернізації та підвищення енергетичної ефективності будівель',
  'Reduction of pollutant emissions into the environment by 20% or more': 'Зменшення обсягу викидів забруднюючих речовин у навколишнє природне середовище від 20% і більше',
  'Substitution of fossil fuels for national purposes, except for peat and gas (methane) from coal deposits, with alternative fuels and alternative (renewable) energy sources in terms of electricity generation per 1 MW of electricity by 50% or more': 'Заміщення горючих корисних копалин загальнодержавного призначення, крім торфу та газу (метану) вугільних родовищ альтернативними видами палива та альтернативними (відновлюваними) джерелами енергії у перерахунку на виробництво 1 МВт електричної енергії від 50% і більше',
  'Reduction of pollutant emissions by 20% or more': 'Зменшення обсягу викидів забруднюючих речовин від 20% і більше',
  'Reduction of the energy intensity of production of a unit of relevant products (services) of the established quality in physical terms compared to the corresponding indicators in force in the previous year (before reconstruction/modernization, and for new production - compared to the indicators of similar production) by 15% or more': 'Зниження енергоємності виробництва одиниці відповідної продукції (надання послуг) встановленої якості в натуральному виразі порівняно з відповідними показниками, що діяли у попередньому році (до реконструкції/модернізації, а для нового виробництва – порівняно з показниками аналогічного виробництва) від 15% і більше',
  'Energy efficiency project (including cogeneration)': 'Проєкт з підвищення енергоефективності (у тому числі когенерація)',
  'Project on switching to alternative fuels and alternative (renewable) energy sources': 'Проєкт  з переходу на альтернативні види палива та альтернативні (відновлювані) джерела енергії',
  'Project on thermal modernization and energy efficiency of buildings': 'Проєкт з термомодернізації та підвищення енергетичної ефективності будівель',
  'Does your project represent an area not mentioned in the previous questions?': 'Ваш проєкт представляє напрям, що не зазначений в попередніх питаннях?',
  'for example:  "Project for the installation of a solar power plant for Vodokanal"': 'наприклад:  «Проект з встановлення СЕС для КП «Водоканал»',
  'Availability of an officially assigned energy manager for the facility:': 'Наявність офіційно закріпленого енерго-менеджеру за об’єктом:',
  'The availability of an energy audit for this facility in the last 5 years': 'Наявність проведеного енергоаудиту для даного об’єкту за останні 5 років',
  'Attach presentation materials in *.pdf or *.pptx format': 'Вкласти презентаційні матеріали у форматі *.pdf або *.pptx',
  'The need to obtain additional permits to implement the project': 'Необхідність отримання додаткових дозвілів на впровадження проєкту',
  'Solutions': 'Рішення',
  'Permits to implement the project': 'Дозвілів на впровадження проєкту',
  'The need to obtain additional permits': 'Необхідність отримання додаткових дозвілів',
  'list of licenses and permits required for the project implementation': 'перелік ліцензій та документів дозвільного характеру, необхідних для реалізації проекту',
  'What social problems will be solved with the help of this project?': 'Які соціальні проблеми будуть вирішенні за допомогою даного проєкту?',
  'Decisions of government and local authorities for the project': 'Рішення органів влади та органів місцевого самоврядування для проекту',
  'Provide a list of decisions of state and local authorities to be involved in the project implementation': 'Укажіть перелік рішень органів державної влади та органів місцевого самоврядування, які мають бути залучені для реалізації проєкту',
  'Analysis of environmental aspects of the project, if applicable': 'Аналіз екологічних аспектів проєкту, у випадку, якщо застосовувався',
  'Project name': 'Назва проєкту',
  'Project direction': 'Напрям проєкту',
  'Legal address of the object': 'Юридична адреса об’єкту проєкта',
  'Form of ownership': 'Форма власності',
  'Region': 'Регіон',
  'Availability of a decarbonization office in the region': 'Наявність офісу декарбонізації в регіоні',
  'Name of the body/organization submitting the project': 'Назва органу/організації, що подає проєкт',
  'Name of the organization (legal entity), project owner': 'Назва організації (юридичної особи), власника проєкта',
  'Code according to the EDRPOU of the organization (legal entity)': 'Код ЄДРПОУ організації (юридичної особи)',
  'Form of organization, project owner': 'Форма організації, власника проєкту',
  'Organization': 'Організація',
  'Project': 'Проєкт',
  'Company name': 'Назва компанії',
  'Registration number': 'Код ЄДРПОУ / ІПН',
  'Registration number (ІПН)': 'Код ІПН',
  'Registration number (EDRPOU)': 'Код ЄДРПОУ',
  'Organizational form': 'Організаційна форма',
  'Type': 'Тип',
  'Field of activities': 'Сфера діяльності',
  "Type of organization's activities": 'Види діяльності',
  'Description of organization\'s activities': 'Опис діяльності ',
  'Phone number': 'Номер телефону',
  'Email': 'Електронна пошта',
  'not filled in': 'не заповнено',
  'Position': 'Посада',
  'Legal address': 'Юридична адреса',
  'Property type': 'Тип власності',
  'Search field': 'Пошук',
  'Address form': 'Форма адреси',
  'Search on map *': 'Пошук на карті *',
  'Search on map': 'Пошук на карті',
  'State': 'Область',
  'City': 'Місто',
  'Street': 'Вулиця',
  'Not': 'Ні',
  'Apartment': 'Квартира',
  'Private house': 'Приватний будинок',
  'Apartment #': 'Квартира №',
  'Postal code': 'Поштовий індекс',
  'Operating mode': 'Режим роботи',
  'From-To': 'Від-до',
  'Hours a day': 'Годин на день',
  'Hours': 'Год',
  'Time to': 'Час до',
  'Time from': 'Час від',
  'Monday': 'Понеділок',
  'Tuesday': 'Вівторок',
  'Wednesday': 'Середа',
  'Thursday': 'Четвер',
  'Friday': 'П\'ятниця',
  'Saturday': 'Субота',
  'Sunday': 'Неділя',
  'Building information': 'Інформація про будівлю',
  'Residential': 'Фізичні особи',
  'Yes': 'Так',
  'No': 'Ні',
  'Number of storeys': 'Кількість поверхів',
  'Building height (m)': 'Висота будівлі (м)',
  'Building height': 'Висота будівлі',
  'Place of installation': 'Місце установки',
  'Roof type': 'Тип даху',
  'Roof': 'Дах',
  'Roof Direction': 'Напрям даху',
  'Roof length (m)': 'Довжина даху (м)',
  'Roof width/depth (m)': 'Ширина/глибина даху (м)',
  'Roof pitch (°)': 'Кут нахилу даху (°)',
  'Roof length': 'Довжина даху',
  'Roof width/depth': 'Ширина/глибина даху',
  'Roof pitch': 'Ухил даху',
  'Place': 'Місце',
  'Same as legal address': 'Така ж як юридична',
  'Contact': 'Контактні дані',
  'Personal data': 'Особисті дані',
  'First name': 'Ім’я',
  'Last name': 'Прізвище',
  'Middle name': 'По-батькові',
  'Phone': 'Телефон',
  'Mail': 'Пошта',
  'This email will be used to store the application. Please enter an accessible email address.': 'Ця електронна адреса буде використовуватися для зберігання програми. Будь ласка, введіть доступну електронну адресу.',
  'Collapse': 'Згорнути',
  '* Required sections must be filled in': '* Необхідно заповнити обов\'язкові розділи',
  'Resources consumption': 'Споживання ресурсів',
  'Electricity usage': 'Споживання електроенергії',
  'Base year': 'Базовий рік',
  'Expand': 'Розкрити',
  'Monthly electricity consumption (kWh)': 'Місячне споживання електроенергії (кВт·год)',
  'Monthly bills (UAH)': 'Щомісячні рахунки (грн.)',
  'Nightly electricity consumption': 'Нічне споживання електроенергії',
  'Tariff per kWh': 'Тариф за кВт*год',
  'Night time tariff (UAH per kWh)': 'Нічний тариф (грн за кВт*год)',
  'Enter the tariff manually': 'Введіть тариф вручну',
  'kWh': 'кВт*год',
  'Monthly electricity consumption': 'Споживання електроенергії на місяць (кВт)',
  'My certificate.pdf': 'My certificate.pdf',
  'Bill for electricity consumption': 'Рахунок за споживання електроенергії',
  'Required voltage': 'Необхідна напруга',
  'Electricity supplier': 'Постачальник електроенергії',
  'UAH per kWh': 'грн за кВт*год',
  'Night time tariff': 'Нічний тариф',
  'Tariff': 'Тариф',
  'Monthly bills': 'Рахунок за електроенергію за місяць (грн)',
  'UAH': 'грн',
  'Gcal': 'Гкал',
  'Gas usage': 'Споживання газу',
  'Current CO2 emissions': 'Поточний викид CO2',
  'The level of energy consumption, which is planned to be reduced, but not less than 15%': 'Рівень споживання енергії, що планується до скорочення, але не менше 15%',
  'The level of energy consumption, which is planned to be reduced': 'Рівень споживання енергії, що планується до скорочення',
  'Planned reductions in greenhouse emissions, CO2 emissions, after project implementation, but not less than 20%': 'Планові скорочення парникових викидів, викидів СО2, після реалізації проєкту, але не менше 20%',
  'Planned reductions in greenhouse emissions, CO2 emissions, after project implementation': 'Планові скорочення парникових викидів, викидів СО2, після реалізації проєкту',
  'The level of energy consumption': 'Рівень споживання енергії',
  'Planned reductions in greenhouse emissions': 'Планове скорочення викидів парникових газів',
  'Financial information': 'Фінансова інформація',
  'Bill offset percentage': 'Відсоток економії від рахунку',
  'Preferred system price (USD)': 'Бажана вартість системи (доларів США)',
  'Preferred system price': 'Бажана вартість системи',
  'Preferred term (years)': 'Бажаний срок (років)',
  'to': 'до',
  'Preferred term': 'Переважний термін',
  'years': 'років',
  'USD': 'USD',
  'Monthly hot water consumption (m3)': 'Споживання гарячої води за місяць (м3)',
  'Heating consumption': 'Споживання теплової енергії',
  'Tariff per m3': 'Тариф за м3',
  'Gas supplier': 'Постачальник газу',
  'Bill for gas consumption': 'Рахунок за споживання газу',
  'Monthly gas consumption': 'Місячне споживання газу',
  'Bill for heating consumption': 'Рахунок за споживання теплової енергії / Рахунок за послуги теплопостачання',
  'Bill for hot water consumption': 'Рахунок за споживання гарячої води',
  'Monthly heating consumption': 'Місячне споживання опалення',
  'Monthly hot water consumption': 'Місячне споживання гарячої води',
  'Heating supplier': 'Постачальник теплової енергії',
  'Heating usage': 'Споживання теплової енергії',
  'Hot water usage': 'Споживання гарячої води',
  'Different tariff for night time usage': 'Інший тариф для нічного використання',
  ////
  'Tariff (kWh)': 'Тариф (кВт*год)',
  'Tariff (UAH per kWh)': 'Тариф (грн за кВт*год)',
  'Tariff (UAH per m³)': 'Тариф (грн за м³)',
  'Night time tariff (kWh)': 'Нічний тариф (кВт*год)',
  'Year consumption (kWh)': 'Річне споживання (кВт*год)',
  'Year consumption (Gcal)': 'Річне споживання  (Гкал)',
  'Monthly consumption': 'Місячне споживання',
  'Monthly consumption (kWh)': 'Місячне споживання (кВт*год)',
  'Monthly consumption (m³)': 'Місячне споживання (м³)',
  'Year bill (UAH)': 'Річний рахунок (грн)',
  'Year bill (Gcal)': 'Річний рахунок (Гкал)',
  'Monthly bill (Gcal)': 'Щомісячний рахунок (Гкал)',
  'Monthly bill (UAH)': 'Щомісячний рахунок (грн)',
  'Year night consumption (kWh)': 'Нічне споживання за рік (кВт*год)',
  'Monthly night consumption': 'Щомісячне нічне споживання',
  'Monthly night consumption (kWh)': 'Щомісячне нічне споживання (кВт*год)',
  'Year night bill (UAH)': 'Річний нічний рахунок (грн)',
  'Year night bill': 'Річний нічний рахунок',
  'Monthly night bill (UAH)': 'Щомісячний нічний рахунок (грн)',
  'Monthly night bill': 'Щомісячний нічний рахунок',
  'Required voltage (V)': 'Необхідна напруга (В)',
  'Replace': 'Замінити',
  'Click to upload': 'Натисніть, щоб завантажити',
  'or drag and drop': 'або перетягніть файл',
  'PDF only (max. 25Mb)': 'Тільки PDF (макс. 25 Мб)',
  'pdf or pptx (max. 25Mb)': 'pdf або pptx (макс. 25 Мб)',
  'Period for which we enter data': 'Період, за який вводимо дані',
  'Year average': 'Середньорічний показник',
  'Monthly average': 'Середньомісячний показник',
  'Monthly estimate (1-12 month)': 'Щомісячний кошторис (1-12 місяць)',
  'January': 'Січень',
  'February': 'Лютий',
  'March': 'Березень',
  'April': 'Квітень',
  'May': 'Травень',
  'June': 'Червень',
  'July': 'Липень',
  'August': 'Серпень',
  'September': 'Вересень',
  'October': 'Жовтень',
  'November': 'Листопад',
  'December': 'Грудень',
  'Day': 'День',
  'Night': 'Ніч',
  'day / night': 'день / ніч',
  'm³': 'м³',
  'Tariff (m³)': 'Тариф (м³)',
  'Tariff (UAH)': 'Тариф (грн)',
  'Tariff (Gcal)': 'Тариф (Гкал)',
  'Year consumption': 'Річне споживання',
  'Year night consumption': 'Нічне споживання за рік',
  'Year bill': 'Річний рахунок',
  'Monthly bill': 'Щомісячний рахунок',
  'UAH per m³': 'грн за м³',
  'UAH per Gcal': 'грн за 1 Гкал',
  'Tariff (UAH per Gcal)': 'Тариф (грн за 1 Гкал)',
  'Hot water supplier': 'Постачальник гарячої води',
  'Environment': 'Екологія',
  'Monthly consumption (Gcal)': 'Місячне споживання (Гкал)',
  'Co2 emission is the release of carbon dioxide gas into the atmosphere. Please provide value of CO2 emission by your organization/household per year.': 'Викиди CO2 - це викиди вуглекислого газу в атмосферу. Будь ласка, вкажіть величину викидів CO2 у вашій організації/домогосподарстві за рік.',
  'Please provide information about your financing preferences:': 'Будь ласка, надайте інформацію про ваші фінансові уподобання:',
  'The percentage of your bill you would like to save with renewable energy.': 'Відсоток вашого рахунку, який ви хотіли б заощадити за рахунок відновлюваної енергії.',
  'Estimated budget for purchasing renewable energy system': 'Орієнтовний бюджет на придбання системи відновлюваної енергетики',
  'Repayment period for allocated funding': 'Період повернення виділених коштів',
  'My solutions': 'Мої рішення',
  'Who will choose solutions?': 'Хто обиратиме рішення?',
  'Our experts will choose': 'Наші фахівці підберуть',
  'Choose yourself': 'Обирай сам',
  'How it works': 'Як це працює',
  'Our expert team collaborates with businesses and communities to seamlessly integrate green solutions, from energy-efficient.': 'Наша команда експертів співпрацює з бізнесом та громадами, щоб безперешкодно інтегрувати "зелені" рішення, починаючи з енергоефективних.',
  'Filters': 'Фільтри',
  'Submit application': 'Подати заявку',
  'About': 'Про нас',
  'Max. 500 characters': 'Макс. 500 символів',
  'Full name': 'Прізвище, ім\'я та по батькові',
  'Full name *': 'Прізвище, ім\'я та по батькові *',
  'Mobile phone': 'Мобільний телефон',
  'Submit': 'Надіслати',
  'Delete solution': 'Видалити рішення',
  'Are you sure you want to delete solution?': 'Ви впевнені, що хочете видалити рішення?',
  'Cancel': 'Скасувати',
  'Yes, delete': 'Так, видалити',
  'Solution': 'Рішення',
  'Category': 'Категорія',
  'Amount': 'Сума',
  'Year of construction': 'Рік будівництва',
  'm': 'м',
  'Gt': 'т',
  't': 'т',
  'Create Application': 'Податися на проєкт',
  'Do you have an account?': 'У вас є обліковий запис?',
  'Do it later': 'Зроби це пізніше',
  'Login via ID.GOV.UA': 'Вхід через ID.GOV.UA',
  'Reset': 'Скинути',
  'Show': 'Показати',
  'Clear all filters': 'Очистити всі фільтри',
  'Yes, load my solutions': 'Так, завантажте мої рішення',
  'You have previously chosen solutions. Load them here?': 'Ви вже обрали рішення. Завантажити їх сюди?',
  'Your solutions have been loaded': 'Ваші рішення завантажено',
  'Solution was removed': 'Рішення було видалено',
  'Quantity of solutions updated': 'Оновлена кількість рішень',
  'Added to my solutions': 'Додано до моїх рішень',
  'Field length 10 digits': 'Довжина поля 10 цифр',
  'Field length 8 digits': 'Довжина поля 8 цифр',
  'Field length 4 digits': 'Довжина поля 4 цифри',
  'This field is required': 'Це поле обов\'язкове для заповнення',
  'Invalid email format or restricted domain': 'Неправильний формат електронної пошти або обмежений домен',
  'Invalid phone number format +38(099) 999 99 99': 'Неправильний формат номера телефону +38(099) 999 99 99',
  'Year consumption (m³)': 'Річне споживання (м³)',
  'Quantity': 'Кількість',
  'Available solutions': 'Доступні рішення',
  'Add to application': 'Додати до заявки',
  'To draft': 'Чернетка',
  'Incorrect time entered': 'Неправильно введено час',
  'Max words count': 'Максимальна кількість слів',
  'Min words count': 'Мінімальна кількість слів',
  'Continue edit': 'Продовжити редагування',
  'My applications': 'Мої заявки',
  'Private house #': 'Приватний будинок №',
  'No options found': 'Варіантів не знайдено',
  'Choose at least one working day': 'Виберіть хоча б один робочий день',
  'Invalid file format': 'Неправильний формат файлу',
  'Upload failed, please try again': 'Не вдалося завантажити, спробуйте ще раз',
  'The file is too large': 'Файл занадто великий',
  'h': 'год',
  'Authorization with an additional integrated electronic identification system ID.GOV.UA': 'Авторизація з додатковою інтегрованою системою електронної ідентифікації ID.GOV.UA',
  'Log In / Sign Up': 'Увійдіть / Зареєструйтеся',
  'UANDP Account': 'UANDP Аккаунт',
  'Go back': 'Повернутись',
  'Application from the organization': 'Заявка від організації',
  'Updates': 'Оновлення',
  'Comment about return': 'Коментар про повернення',
  'Comment about rejected': 'Коментар про відхилення',
  'Edit Application': 'Редагувати заявку',
  'Working days': 'Робочі дні',
  'Working hours': 'Робочі години',
  'Project information': 'Про проєкт',
  'Technical displays': 'Технічні показники',
  'Value must be between ': 'Значення має бути від ',
  ' and ': ' до ',
  'Value should be no more than ': 'Значення має бути не більше ',
  'The year of the basic calculation of energy resource costs in the calculation for the project': 'Рік базового нарахування витрат енергоресурсів в розрахунку до проєкту',
  'For the base year, taken into account in the project, kWh': 'За базовий рік, що врахований в проєкті, кВт*год',
  'The actual level of energy consumption': 'Фактичний рівень споживання енергоресурсів об’єкту',
  'Tariff included in the project, UAH per 1 kW/h': 'Тариф що врахований в проєкті, грн за 1 Квт/год',
  'Tariff for the base year energy resource': 'Тариф на енергоерсурс базового року',
  'The actual level of energy consumption of the facility': 'Фактичний рівень споживання енергоресурсів об’єкту',
  'Level for 2023, kWh': 'Рівень за 2023 рік, кВт*год',
  'Tariff for energy resource in 2023, UAH per 1 kW/h': 'Тариф на енергоерсурс 2023 року, грн за 1 Квт/год',
  'The level, which is planned to be reduced, but not less than 15%': 'Рівень, що планується до скорочення, але не менше 15%',
  'After project implementation, but not less than 20%': 'Після реалізації проєкту, але не менше 20%',
  'Planned reductions in greenhouse emissions, CO2 emissions': 'Планові скорочення парникових викидів, викидів СО2',
  'Determination of project sustainability, maximum service life, in years': 'Визначення стійкості проєкту, максимальний строк служби, в роках',
  'The project is expected to be implemented with the involvement of equipment manufacturers': 'Реалізація проєкту передбачається з залученням виробників обладнання',
  'Project type': 'Тип проєкту',
  'Solar energy': 'Сонячна енергія',
  'Project files': 'Файли проєкту',
  'Project description': 'Опис проєкту',
  'General information about the project. Definition of the problem being solved, as well as ways and means of its implementation. List of proposed measures for energy saving and decarbonization. (from 1 to 200 words)': 'Загальна інформація про проєкт. Визначення проблеми, що вирішується, а також шляхи та способи її реалізації. Перелік запропонованих заходів з енергозбереження та декарбонізації. (від 1 до 200 слів)',
  'Files with additional information about the project (feasibility study, business plan, presentation materials, energy auditor\'s report, etc.': 'Файли з додатковою інформацією про проєкт (ТЕО(техніко-економічне обгрунтування), бізнес план, презентаційні матеріали, звіт енергоаудитора тощо)',
  'day': 'день',
  'Previous': 'Попередній розділ',
  'Next': 'Наступний розділ',
  'Section': 'Розділ',
  'Menu': 'Меню',
  'Close': 'Закрити',
  'Email (login ID)': 'Електронна пошта (ID логіну)',
  'Email (login ID) *': 'Електронна пошта (ID логіну) *',
  'This email will be used for account authorization': 'Ця електронна пошта буде використовуватися для входу в обліковий запис',
  'I have filled out the form': 'Я заповнив форму',
  'The form is filled in': 'Форма заповнена',
  'Yes': 'Так',
  'No': 'Ні',
  'Fill additional form': 'Додатково заповнити форму',
  '': '',
  'Financial indicators': 'Фінансові показники',
  'Indicators': 'Показники',
  'Payback period, years': 'Строк окупності, роки',
  'Internal rate of return, %': 'Внутрішня норма доходності, %',
  'If calculations are available': 'За наявності розрахунків',
  'Cost of the project, hryvnia': 'Вартість проєкту, гривень',
  'The amount is indicated in UAH with kopecks in digital, including VAT': 'Сума вказується у гривні з копійками в цифровому, включаючи ПДВ',
  'Amount of capital costs of the project, hryvnia': 'Сума капітальних витрат проєкту, гривень',
  'Region, district, city/village, street, house/office number': 'Область, район, місто/село, вулиця, №будинку/офісу',
  'Amount of operating expenses for the project, hryvnia': 'Сума операційних витрат по проєкту, гривень',
  'Planned project financing': 'Планове фінансування проєкту',
  'You can choose several options': 'Можна обрати декілька варіантів',
  'What financing mechanisms is the project owner willing to consider?': 'Які механізми фінансування готовий розглянути власник проєкту',
  'From the start of development of project documentation to completion of commissioning work': 'Від моменту початку розробки проєктної документації до завершення пуско-налагоджувальних робіт',
  'Project implementation period, full months': 'Строк реалізації проєкту, повних місяців',
  'The need to carry out work related to the technical preparation of the project': 'Необхідність проведення робіт, пов’язаних з технічною підготовкою проекту',
  'The need for outside funding related to the technical preparation of the project': 'Необхідність стороннього фінансування, пов’язаних з технічною підготовкою проекту',
  'Reduction of the energy intensity of production of a unit of products/services': 'Зниження енергоємності виробництва одиниці продукції/послуг',
  'Substitution of combustible minerals': 'Заміщення горючих корисних копалин',
  'Achievement of energy efficiency requirements for buildings (class)': 'Досягнення вимог до енергетичної ефективності будівель (класу)'
}


const engineer = {
  'No solutions added. Choose available solutions.': 'Рішення не додано. Виберіть доступні рішення.',
  'System design': 'Системний дизайн',
  'Add': 'Додати',
  'General info': 'Загальна інформація',
  'Application': 'Заявка',
  'Status': 'Статус',
  'Last status change date': 'Дата зміни статусу',
  'Issue date': 'Дата створення',
  'Wish solutions': 'Бажані рішення',
  'System price': 'Ціна системи',
  'USD': 'USD',
  'Solution cost (UAH)': 'Вартість рішення (грн)',
  'Solution cost (USD)': 'Вартість рішення (USD)',
  'Solution cost': 'Вартість рішення',
  'Installation cost': 'Вартість встановлення',
  'Installation cost (UAH)': 'Вартість встановлення (грн)',
  'Installation cost (USD)': 'Вартість встановлення (USD)',
  'Total cost': 'Загальна вартість',
  'Addition cost': 'Вартість доповнення',
  'Addition cost (UAH)': 'Вартість доповнення (грн)',
  'Addition cost (USD)': 'Додаткова вартість (USD)',
  'Name of addition': 'Назва доповнення',
  'Add additions cost': 'Додати',
  'Installation details': 'Параметри встановлення',
  'Direction': 'Напрям',
  'Parameters of Connection': 'Параметри підключення',
  'Ground': 'Наземне встановлення',
  'Vertical': 'Вертикальне',
  'Horizontal': 'Горизонтальне',
  'Parallel': 'Паралельно',
  'Sequential': 'Послідовно',
  'Economy month by month': 'Генерація',
  'Electricity production (kWh)': 'Виробництво електроенергії (кВт*год)',
  'Level/Bill offset (%)': 'Економія електроенергії (%)',
  'Level (UAH)': 'Економія електроенергії (грн)',
  'Level (USD)': 'Економія електроенергії (USD)',
  'Economy level/Bill offset': 'Економія електроенергії',
  'Economy level': 'Економія електроенергії',
  'Incentive': 'Знижки/модифікатори вартості',
  'Buy-back electricity rate': 'Тариф зворотного викупу електроенергії',
  'After incentives': 'З урахуванням знижок та модифікаторів',
  'Financing option': 'Параметри фінансування',
  'Term (months)': 'Строк (міс.)',
  'Term': 'Строк',
  'month': 'міс.',
  'Down Payment (UAH)': 'Початковий внесок (грн)',
  'Down Payment': 'Початковий внесок',
  'Down Payment (USD)': 'Початковий внесок (USD)',
  'Interest rate (%)': 'Процентна ставка (%)',
  'Interest rate': 'Процентна ставка',
  'Monthly payment': 'Щомісячний платіж',
  'Monthly payment (UAH)': 'Щомісячний платіж (грн)',
  'Monthly payment (USD)': 'Щомісячний платіж (USD)',
  'Proposal': 'Комерційна пропозиція',
  'Upload proposal': 'Завантажити пропозицію',
  'Comment': 'Коментар',
  'Your comment': 'Ваш коментар',
  'Reject application': 'Відхилити заявку',
  'You need to write the reason for reject. Describe the details of your decision.': 'Вам потрібно написати причину відмови. Опишіть деталі рішення.',
  'Return to applicant': 'Повернути заявнику',
  'Link to the presentation': 'Посилання на презентацію',
  'Reject': 'Відхилити',
  'Rejected': 'Вiдхилено',
  'You need to write the reason for returning to the applicant. Describe the details of your decision.': 'Вам необхідно написати причину повернення заявнику. Опишіть деталі рішення.',
  'Rejected': 'Відхилено',
  'Submitted': 'Подано',
  'Returned to applicant': 'Повернуто заявнику',
  'Get started': 'Почати',
  'Gt': 'т',
  't': 'т',
  'Choose available solutions': 'Обирайте доступні рішення',
  'await': 'очікування',
  'in progress': 'На обробці',
  'reject': 'Відмовлено',
  'rejected': 'Вiдхилено',
  'submitted': 'Опрацьовано',
  'return to applicant': 'Повернуто',
  'Application successfully returned to applicant': 'Заявку успішно повернуто заявнику',
  'Application successfully rejected': 'Заявка успішно відхилена',
  'Number must be less than': 'Число повинно бути менше, ніж',
  'Sent': 'Відправлено',
  'Returned': 'Повернуто',
  'Application successfully submitted': 'Заявка успішно відправлена',
  'Invalid URL format': 'Неправильний формат URL-адреси',
  'returned': 'Повернуто',
  'processed': 'Опрацьовано',
  'Processed': 'Опрацьовано',
  'pending': 'Очікування',
  'Pending': 'Очікування',
  'In progress': 'На обробці',
  'return to application': 'Повернуто',

}

export default {
  ua: {
    ...type,
    ...field_of_activities,
    ...roof_direction,
    ...type_of_org_activities,
    ...equipment_manufacturers_types,
    ...property_type,
    ...roof_type,
    ...required_voltage,
    ...ua,
    ...engineer,
    ...financing_mechanisms_fields,
    ...planned_project_financing_fields,
    ...regions,
    ...ownership_form,
    ...above_min_requirements,
    ...field_of_actifity,
    ...organization_form,
  },
  en: {
    ...electricity_supplier,
    ...equipment_manufacturers_types,
  }
};


export {
  equipment_manufacturers_types,
  organization_form,
  type,
  field_of_activities_obj,
  electricity_supplier,
  required_voltage,
  regions,
  ownership_form,
  above_min_requirements,
  field_of_actifity,
  financing_mechanisms_fields,
  planned_project_financing_fields,
}
